var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useState, useEffect } from 'react';
export var useWindowSize = function () {
  var _a = __read(useState({
      width: typeof window !== 'undefined' ? window.innerWidth : 0,
      height: typeof window !== 'undefined' ? window.innerHeight : 0
    }), 2),
    windowSize = _a[0],
    setWindowSize = _a[1];
  useEffect(function () {
    if (typeof window === 'undefined') {
      return; // Exit early if window is not defined (e.g., during SSR)
    }
    var timeoutId;
    var handleResize = function () {
      clearTimeout(timeoutId);
      // Debounce the resize update
      timeoutId = setTimeout(function () {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      }, 100); // Adjust debounce delay as needed
    };
    window.addEventListener('resize', handleResize);
    return function () {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
};